import { TableMap } from '../table-map';
import { isSelectionType } from './is-selection-type'; // Get the selection rectangle. Returns `undefined` if selection is not a CellSelection.

export var getSelectionRect = function getSelectionRect(selection) {
  if (!isSelectionType(selection, 'cell')) {
    return;
  }

  var start = selection.$anchorCell.start(-1);
  var map = TableMap.get(selection.$anchorCell.node(-1));
  return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};